var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-text-field',{staticClass:"converterInput",attrs:{"type":"number"},model:{value:(_vm.sourceValue),callback:function ($$v) {_vm.sourceValue=$$v},expression:"sourceValue"}}),_c('span',[_vm._v(" "+_vm._s(_vm.sourceUnit)+" = "+_vm._s(_vm.targetValue)+" "+_vm._s(_vm.targetUnit))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }